import { StyledIconBarContainer } from "./IconBar.styles";

type IconBarProps = {
  children?: React.ReactNode;
  offset?: number;
};

export const IconBar: React.FC<IconBarProps> = ({ children, offset = 0 }: IconBarProps) => {
  return (
    <StyledIconBarContainer className="icon-bar-container" sx={{ paddingTop: `${offset}px` }}>
      <div className="icon-bar-content">{children}</div>
    </StyledIconBarContainer>
  );
};
